module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'npo8exl9',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
